import { styled } from 'baseui'
import { FlexColumn } from '@/shared/theme/styled-components'

export const ModalLayout = styled(FlexColumn, {
  gap: '1.25rem',
  padding: '1rem 0 1.25rem 0',
})

export const Title = styled('h2', ({ $theme }) => ({
  fontSize: '1.0625rem',
  fontWeight: 600,
  color: $theme.colors.textBody,
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
}))

export const Subtitle = styled('p', ({ $theme }) => ({
  fontSize: '0.8125rem',
  color: $theme.colors.textSecondaryAlt,
  lineHeight: '1.4',
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
}))

export const FormWrapper = styled('div', {
  display: 'grid',
  gridTemplateColumns: '1fr',
  rowGap: '0.75rem',
})

export const TwoCols = styled('div', {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  columnGap: '0.75rem',
  rowGap: '0.75rem',
})

export const AssignmentChoice = styled('div', {})

export const SuccessContainer = styled(FlexColumn, {
  alignItems: 'center',
  gap: '1.5rem',
  paddingTop: '2rem',
  paddingBottom: '1rem',
})

export const SuccessMessage = styled('p', ({ $theme }) => ({
  fontSize: '1rem',
  fontWeight: 600,
  color: $theme.colors.successAlt,
  lineHeight: '1.5rem',
  textAlign: 'center',
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
}))

export const TriggerWrapper = styled('div', ({ $spacedBelow }) => ({
  margin: $spacedBelow ? '0 0 0.625rem 0' : 0,
}))

export const TriggerButton = styled('button', ({ $theme, $plainIcon, $inRedesignedPanel }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: '0.625rem',
  padding: '0.75rem 0.875rem',
  borderRadius: $inRedesignedPanel ? '1rem' : '0.75rem',
  border: `1px solid ${$inRedesignedPanel ? $theme.colors.borderPulseCard : $theme.colors.borderOpaque}`,
  backgroundColor: $theme.colors.backgroundPrimary,
  color: $theme.colors.contentPrimary,
  cursor: 'pointer',
  transition: 'background-color 0.12s, box-shadow 0.12s, border-color 0.12s, transform 0.06s',
  outline: 'none',
  boxShadow: 'none',
  ':hover': {
    backgroundColor: $theme.colors.gray100,
    borderColor: $theme.colors.primary450,
    boxShadow: $theme.lighting.shadow200,
  },
  ':hover > [data-role="trigger-icon"]': {
    backgroundColor: $plainIcon ? 'transparent' : $theme.colors.lightPrimary,
  },
  ':active': { transform: 'translateY(0.0625rem)' },
  ':focus-visible': {
    boxShadow: `0 0 0 0.1875rem ${$theme.colors.accent}`,
    borderColor: $theme.colors.accent,
  },
}))

export const TriggerIcon = styled('div', ({ $theme, $plain }) => ({
  position: 'relative',
  display: 'grid',
  placeItems: 'center',
  width: '1.875rem',
  height: '1.875rem',
  borderRadius: '999px',
  backgroundColor: $plain ? 'transparent' : $theme.colors.primary100,
  flexShrink: 0,
  transition: 'background-color 120ms',
}))

export const TriggerText = styled('span', () => ({
  fontWeight: 600,
  fontSize: '0.875rem',
  color: 'inherit',
}))

export const BadgeDot = styled('span', ({ $theme }) => ({
  position: 'absolute',
  top: '-0.125rem',
  right: '-0.125rem',
  width: '0.625rem',
  height: '0.625rem',
  borderRadius: '50%',
  backgroundColor: $theme.colors.negative400,
  boxShadow: `0 0 0 0.125rem ${$theme.colors.white}`,
}))

export const PopoverList = styled('div', {
  minWidth: '15rem',
  maxWidth: '20rem',
  padding: '0.5rem 0.625rem',
  display: 'grid',
  rowGap: '0.5rem',
})

export const PopTitle = styled('div', {
  fontWeight: 600,
  fontSize: '0.875rem',
  marginBottom: '0.25rem',
})

export const PopItem = styled('div', ({ $theme }) => ({
  fontSize: '0.75rem',
  lineHeight: '1rem',
  padding: '0.375rem 0.5rem',
  borderRadius: '0.5rem',
  backgroundColor: $theme.colors.bgLight,
  display: 'grid',
  rowGap: '0.125rem',
}))

export const AddToCalendarButton = styled('a', ({ $theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.5rem',
  padding: '0.5rem 0.75rem',
  borderRadius: '9999px',
  border: `1px solid ${$theme.colors.borderLight}`,
  textDecoration: 'none',
  cursor: 'pointer',
  ':hover': { backgroundColor: $theme.colors.bgHoverLight },
}))
